import { render, staticRenderFns } from "./DealItem.vue?vue&type=template&id=77a83402&scoped=true"
import script from "./DealItem.vue?vue&type=script&lang=js"
export * from "./DealItem.vue?vue&type=script&lang=js"
import style0 from "./DealItem.vue?vue&type=style&index=0&id=77a83402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a83402",
  null
  
)

export default component.exports